
/* START_TEMPLATE */
define('hbs!app/templates/match_pro_input',['hbs','Handlebars', 'hbs!app/templates/_label'], function( hbs, Handlebars ){ 
var t = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var stack1, buffer = "";
  stack1 = this.invokePartial(partials['./_label'], '', './_label', depth0, undefined, helpers, partials);
  if (stack1 != null) { buffer += stack1; }
  return buffer + "  <div id=\"dd-company-name-input\"> </div>\n";
},"usePartial":true});
Handlebars.registerPartial('app/templates/match_pro_input', t);
return t;
});
/* END_TEMPLATE */
;
